// Location: src/components/CircularNavigation.js
import React from 'react';
import { Link } from 'react-router-dom';
import AnimateOnScroll from './AnimateOnScroll.js';

const NavCard = ({ to, title, description, icon }) => (
  <Link
    to={to}
    className="group bg-white/90 backdrop-blur-sm rounded-lg p-7 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center border border-gray-200/50 border-t-2 border-t-green-700"
  >
    <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-3">
      {icon}
    </div>
    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-green-700 transition-colors">
      {title}
    </h3>
    <p className="text-sm text-gray-600 leading-relaxed mb-3">
      {description}
    </p>
    <span className="text-sm font-semibold text-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300 inline-flex items-center gap-1">
      Learn More
      <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" /></svg>
    </span>
  </Link>
);

/* Inline SVG icons — consistent stroke style */
const ServicesIcon = () => (
  <svg className="w-6 h-6 text-green-700" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    {/* Spray bottle body */}
    <rect x="7" y="10" width="10" height="11" rx="1.5" strokeLinecap="round" strokeLinejoin="round" />
    {/* Trigger/handle */}
    <path strokeLinecap="round" strokeLinejoin="round" d="M10 10V7h4v3" />
    {/* Nozzle */}
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 7V5h2l1-2" />
    {/* Spray lines */}
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 3l2-1M16.5 5l2 0M16 7l2 1" />
  </svg>
);

const LeafIcon = () => (
  <svg className="w-6 h-6 text-green-700" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21c-4-4-8-8-8-13a8 8 0 0 1 16 0c0 5-4 9-8 13Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 11V21" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 15c1.5-1 3-2 3-4" />
  </svg>
);

const ClipboardCheckIcon = () => (
  <svg className="w-6 h-6 text-green-700" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" strokeLinecap="round" strokeLinejoin="round" />
    <path strokeLinecap="round" strokeLinejoin="round" d="m9 14 2 2 4-4" />
  </svg>
);

const CircularNavigation = () => {
  return (
    <AnimateOnScroll animation="fade-in-up" className="py-8 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 lg:gap-8 max-w-5xl mx-auto">
        <NavCard
          to="/services"
          icon={<ServicesIcon />}
          title="Services"
          description="Bare ground, turf, noxious weed, aquatic, high-rail, and more herbicide programs."
        />
        <NavCard
          to="/ecopractices"
          icon={<LeafIcon />}
          title="IPM Practices"
          description="Science-based herbicide application using Integrated Pest Management principles."
        />
        <NavCard
          to="/processes"
          icon={<ClipboardCheckIcon />}
          title="Our Process"
          description="From site assessment to GPS-tracked application — precision at every step."
        />
      </div>
    </AnimateOnScroll>
  );
};

export default CircularNavigation;
